import { Typography } from 'antd';

import { LeadModel } from '@/typings/models/Lead';
import { useHasMarketingDataAccess } from '@/utils/hooks';

const UtmMedium = ({lead}: {lead: LeadModel, isTable?: boolean}) => {
  const hasMarketingDataAccess = useHasMarketingDataAccess();
  const medium = lead?.customer?.utm_medium;

  if (!hasMarketingDataAccess) return null;
  if (!medium) return <span>-</span>;

  return <Typography.Text ellipsis={{ tooltip: medium }}>{medium}</Typography.Text>;
}

export default UtmMedium
